import { render, staticRenderFns } from "./AdministrationPageMobile.vue?vue&type=template&id=0a347d90&scoped=true&"
import script from "./AdministrationPageMobile.vue?vue&type=script&lang=js&"
export * from "./AdministrationPageMobile.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationPageMobile.vue?vue&type=style&index=0&id=0a347d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a347d90",
  null
  
)

export default component.exports